<template>
  <div class="bodyWrapper">
    <div class="container">
      <div class="menu-wrapper">
        <img src="../../assets/logo_blue.png" alt="Smiley face" class="logo" />
        <select class="monthDropdown" required="true" v-model="selectedMonth" @change="onChange($event)">
          <option value="" disabled selected>{{ $t('indexVue.monthDefault') }}</option>
          <option v-for="(month, key) in months" v-bind:value="month" :key="key"
          >{{ month.name }}
          </option>
        </select>
        <div class="addPerson" v-on:click="modalAddOpened = true">+</div>
        <div class="addPerson log-out-button" v-on:click="logout">
          <font-awesome-icon icon="sign-out-alt" />
        </div>
      </div>
      <div class="header">
        <div style="display: inline-flex">
          <input type="checkbox" class="checkBoxStyle" v-model="allSelected" />
          <span style="margin-right: 1em ">{{ $t('indexVue.selectAll') }}</span>
          <div style="width: 2em;">
            <transition name="fade">
              <font-awesome-icon
                  v-if="selected.length == 1"
                  @click="modalEditOpened = true"
                  class="editIcon"
                  icon="user-edit"
              />
            </transition>
          </div>
          <div style="width: 2em;">
            <transition name="fade">
              <font-awesome-icon
                  v-if="selected.length > 0"
                  @click="deleteContractor"
                  class="deleteIcon"
                  icon="trash"
              />
            </transition>
          </div>
        </div>
        <div class="header_item">
          <span class="header-span">{{ $t('indexVue.timeColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.ratesColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.activeColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.pasiveColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.discountColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.extraColumn') }}</span>
          <span class="header-span">{{ $t('indexVue.totalColumn') }}</span>
        </div>
      </div>
      <div class="table">
        <transition-group name="list" tag="p">
          <invoice_item
              v-for="contractor in contractorsFilter('active')"
              :key="contractor.id"
              :contractor="contractor"
              :selectedMonth="selectedMonth"
          >
            <input
                type="checkbox"
                class="checkBoxStyle"
                :value="contractor"
                v-model="selected"
            />
          </invoice_item>
        </transition-group>
        <transition-group name="list" tag="p">
          <invoice_item
              v-for="contractor in contractorsFilter('deactive')"
              :key="contractor.id"
              :contractor="contractor"
              :selectedMonth="selectedMonth"
          >
            <input
                type="checkbox"
                class="checkBoxStyle"
                :value="contractor"
                v-model="selected"
            />
          </invoice_item>
        </transition-group>
      </div>
      <div class="buttons">
        <button
            :disabled="selected.length < 1"
            class="myButton generate"
            @click="generatePDF"
        >
          {{ $t('indexVue.generatePDFButton') }}
        </button>
        <button
            :disabled="selected.length < 1"
            class="myButton generate"
            @click="generateXML"
        >
          {{ $t('indexVue.generateXMLButton') }}
        </button>
        <button
            :disabled="selected.length < 1"
            class="myButton generate"
            @click="send"
        >
          {{ $t('indexVue.sendInvoicesButton') }}
        </button>
        <button
            :disabled="selected.length < 1"
            class="myButton generate"
            @click="sendToAccountant"
        >
          {{ $t('indexVue.sendInvoicesToAccButton') }}
        </button>
      </div>
      <transition name="fade">
        <div class="modalWrapper" v-if="modalAddOpened">
          <div class="modalView">
            <employee_add_form
                modal-title="Add Contractor"
                :modalAdd="true"
                :date="selectedMonth"
                @finished="closeModal"
                v-click-outside="closeModal"
            />
          </div>
        </div>
        <div class="modalWrapper" v-if="modalEditOpened">
          <div class="modalView">
            <employee_add_form
                modal-title="Edit Contractor"
                :modalAdd="false"
                :date="selectedMonth"
                :contractorForEdit="selected[0]"
                @finished="closeModal"
                v-click-outside="closeModal"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import invoice_item from './employee_row';
import employee_add_form from './add_edit_modal';
import vClickOutside from 'v-click-outside';
import services from '../../services/services';
import { mapGetters } from 'vuex';
import moment from 'moment';
import swal from 'sweetalert';
//import mailConfig from '../../config/mailConfig';

const Swal = require('sweetalert2');

export default {
  name: 'invoice',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    this.monthsToTodayMoment();
    this.selectedMonth = this.months[0];
    this.$store.commit('RESET_CONTRACTORS');
    this.$store.dispatch('getContractors', {seasonFrom: this.selectedMonth.value, seasonTo: this.selectedMonth.endOfMonth});
  },
  data() {
    return {
      allSelected: false,
      months: [],
      selected: [],
      selectedMonth: {},
      modalAddOpened: false,
      modalEditOpened: false,
      modalData: {
        title: '',
        addModal: true,
      }
    };
  },
  watch: {
    allSelected: function () {
      if (this.allSelected) {
        this.selected = [...this.contractors].filter((contractor) => contractor.active);
      } else {
        this.selected = [];
      }
    },
    selected: function () {
      if (this.selected.length === this.contractors.length) {
        this.allSelected = true;
      }
    },
  },
  components: {
    invoice_item,
    employee_add_form,
  },

  computed: {
    ...mapGetters(['contractors']),
  },
  methods: {
    contractorsFilter(status) {
      if (status === 'active') {
        return this.contractors.filter(contractor => contractor.active === true);
      } else {
        return this.contractors.filter(contractor => contractor.active === false);
      }
    },
    onChange() {
      this.$store.commit('RESET_CONTRACTORS');
      this.$store.dispatch('getContractors', {seasonFrom: this.selectedMonth.value, seasonTo: this.selectedMonth.endOfMonth});
    },
    logout() {
      this.$store.dispatch('logOut');
    },
    deleteContractor() {
      // Pridat overenie ci sa pouzivate nesnazi zmazat sam seba ak ano chybova hlaska ak nie zmazat

      swal({
        title: this.$t('indexVue.deleteContractorErrorTitle'),
        text: this.$t('indexVue.deleteContractorErrorText'),
        icon: 'warning',
        buttons: [this.$t('indexVue.deleteContractorErrorCancelButton'), this.$t('indexVue.deleteContractorErrorOKButton')],
        dangerMode: true,
      })
          .then((willDelete) => {
            if (willDelete) {
              for (let contractor of this.selected) {
                contractor.active = false;
                this.$store.dispatch('deleteContractor', contractor);
                this.selected = [];
                this.allSelected = false;
                Swal.fire({
                  title: this.$t('indexVue.successTitle'),
                  text: this.$t('indexVue.deleteContractorSuccessText'),
                  icon: 'success',
                  confirmButtonText: this.$t('indexVue.okButton'),
                });
              }
            } else {
              Swal.fire({
                title: this.$t('indexVue.deleteContractorInfoTitle'),
                text: this.$t('indexVue.deleteContractorInfoText'),
                icon: 'info',
                confirmButtonText: this.$t('indexVue.okButton'),
              });
              this.selected = [];
              this.allSelected = false;
            }
          });
    },
    generatePDF() {
      for (let person of this.selected) {
        services.getPDF(person, this.selectedMonth.value)
            .then(response => {
              let blob = new Blob([response.data], {
                type: 'application/arraybuffer',
              });
              var url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = `${person.firstName}_${person.lastName}_${this.selectedMonth.value}.pdf`;
              a.click();
              a.remove();
              setTimeout(() => window.URL.revokeObjectURL(url), 100);
            });
      }
      this.selected = [];
      this.allSelected = false;
    },
    generateXML() {
      for (let person of this.selected) {
        let hours = parseFloat(person.invoice.hours);
        let rate = parseFloat(person.invoice.rate);
        let discount = parseFloat(person.invoice.discount);
        let reward = parseFloat(person.invoice.reward);

        let total = ((hours * rate) - discount) + reward;

        person.invoice.total = total;
      }

      services
          .getXML({people: this.selected, time: this.selectedMonth, transactionCount: this.selected.length})
          .then((response) => {
            if (response.status === 200) {
              let blob = new Blob([response.data], {
                type: 'application/arraybuffer',
              });
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              let date = moment().format('YYYY-MM');
              link.download = `statements-` + date + `.xml`;
              link.click();
              swal({
                title: this.$t('indexVue.successTitle'),
                text: this.$t('indexVue.generateXMLSuccessText'),
                icon: 'success',
                button: this.$t('indexVue.okButton'),
              });
            }
          });
      this.selected = [];
      this.allSelected = false;
    },
    send() {
      for (let person of this.selected) {
        services
            .sendMails(person, this.selectedMonth.value, 'false', '-')
            .then((response) => {
              if (response.status > 199 && response.status < 300) {
                swal({
                  title: this.$t('indexVue.successTitle'),
                  text: this.$t('indexVue.mailSuccessText'),
                  icon: 'success',
                  button: this.$t('indexVue.okButton'),
                });
              }
            });
      }

      /*

      const mails = mailConfig.accountantsMails;

      for (let mail of mails) {
        for (let person of this.selected) {
          services
          .sendMails(person, this.selectedMonth.value, 'true', mail)
          .then((response) => {
            if (response.status === 200) {
              swal({
                title: this.$t('indexVue.successTitle'),
                text: this.$t('indexVue.mailSuccessText'),
                icon: "success",
                button: this.$t('indexVue.okButton'),
              });
            }
          });
        }
      }

      */

      this.selected = [];
      this.allSelected = false;
    },
    sendToAccountant() {
      let persons = [];
      for (let person of this.selected) {
        persons.push(person);
      }

      services
          .sendMailsToAccountant(persons, this.selectedMonth.value, 'false', '-')
          .then((response) => {
            if (response.status > 199 && response.status < 300) {
              swal({
                title: this.$t('indexVue.successTitle'),
                text: this.$t('indexVue.mailSuccessText'),
                icon: 'success',
                button: this.$t('indexVue.okButton'),
              });
            }
          });

      this.selected = [];
      this.allSelected = false;
    },
    closeModal: function () {
      this.modalAddOpened = false;
      this.modalEditOpened = false;
      this.allSelected = false;
      this.selected = [];
    },
    monthsToTodayMoment() {
      let startDate = moment('2020-01-01');
      let today = moment();

      while (startDate.isBefore(today)) {
        this.months.unshift({
          name: startDate.format('MMMM YYYY'),
          value: startDate.format('YYYY-MM-DD'),
          endOfMonth: moment(startDate).clone().endOf('month').format('YYYY-MM-DD'),
        });
        startDate.add(1, 'month');
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/colors.scss";

@media only screen and (max-width: 600px) {
  .bodyWrapper {
    .container {
      width: 90%;
      padding: 0 1em;
      box-sizing: border-box;

      .menu-wrapper {
        box-sizing: border-box;
        display: flex;
        width: 80vw;
        align-self: center;
        align-items: center;
        padding: 1em 0 0 0;
        flex-wrap: wrap;

        .logo {
          width: 12.5em;
          margin: 0 auto 1em auto;
        }

        .monthDropdown {
          margin-left: auto;
          width: 10em;
        }

        .addPerson {
          margin: 0 0 0 1em;
        }

        .log-out-button {
          margin-right: auto;
        }
      }

      .header_item {
        display: none;
      }

      .header {
        height: 1em;
        margin-top: 1em;
        margin-bottom: 0.5em;
      }

      .table {
        height: 60vh;
        width: 100%;
      }

      button {
        width: 90vw;
      }
    }
  }
}

@media (min-width: 601px) {
  .bodyWrapper {
    position: relative;

    .container {
      width: 80%;
      max-width: 70em;
      position: relative;
      padding: 0 3em;

      .menu-wrapper {
        position: relative;
        display: inline-flex;
        width: 100%;
        padding: 1em 0;
        align-items: flex-end;
        height: 10em;

        .logo {
          margin-bottom: -0.6em;
          margin-right: auto;
          width: 12.5em;
        }

        .monthDropdown {
          width: 12em;
        }

        .addPerson {
          margin-left: 1em;
        }
      }

      .header {
        height: 1em;
        margin: 2em 0 1em 0;
      }
    }
  }
}

.bodyWrapper {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  background: $background;

  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 1em auto 0 auto;
    background: $gray;
    border: 5px solid $company-accent;
    border-bottom: none;
    border-top-left-radius: 2em;
    border-top-right-radius: 2em;
    box-shadow: 10px 10px rgba(0, 0, 0, 0.08);
  }

  .menu-wrapper {
    .monthDropdown {
      height: 2em;
      font-size: 1rem;
      display: inline-block;
      border: none;
      background-color: $light-brown;
      cursor: pointer;
      border-radius: 0.5em;
      padding: 0 0.75em;
      transition: all 0.2s ease-in-out;
      -moz-appearance: none;

      &:focus {
        outline: 0;
      }

      &:hover {
        background-color: $company-secondary;
      }
    }

    .addPerson {
      height: 2em;
      width: 2em;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      background: $light-brown;
      cursor: pointer;
      color: $company-primary;
      transition: all 0.2s ease-in-out;

      &:hover {
        background: $company-secondary;
      }
    }
  }

  .header {
    color: $company-primary;
    min-width: 93%;
    font-weight: normal;
    align-items: center;
    padding: 0 0 0 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      color: $company-primary;
    }

    .editIcon {
      padding: 0 0.3em;
      color: $company-primary;

      &:hover {
        color: $company-accent;
        transform: scale(1.2);
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
    }

    .deleteIcon {
      color: $company-primary;
      padding: 0 0.3em;

      &:hover {
        color: red;
        transform: scale(1.2);
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
    }

    .header_item span {
      padding: 0 0.9em;
    }

  }

  .table {
    display: flex;
    flex-direction: column;
    min-width: 100%;
    overflow-y: scroll;
    margin-bottom: 1em;
    scrollbar-color: $company-accent #f2c51740;
    scrollbar-width: thin;
    height: 100%;
  }

  button {
    width: 33%;
    display: inline-block;
    padding: 0.7em 0;
    margin: 0 0.5em;
    border: 0.1em solid $gray;
    border-radius: 15px;
    background-color: $gray;
    color: $company-primary;
    font-weight: bold;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .checkBoxStyle {
    margin: auto 1em auto 0;
    transform: scale(1.2);
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1.5em;
    width: 100%;
    height: 3.5em;
    box-sizing: border-box;

    .myButton {
      font-size: 0.9em;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      outline-style: none;

      &:hover {
        color: $company-primary;
        background-color: $company-secondary;
      }

      &:active {
        background: $gray;
      }

      &:disabled {
        background-color: $hover-gray;
        cursor: unset;
      }
    }

    .generate {
      background: $company-accent;
    }
  }
}

.modalWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.35s ease-in-out;

  .modalView {
    width: 40%;
    //max-width: 30em;
    height: 70%;
    min-height: 20em;
    margin: 5em auto;
    background: white;
    border-radius: 1em;
  }
}

/*animations*/

.list-item {
  display: flex;
  flex-direction: column;
}

.list-enter-active {
  transition: all 0.7s;
}

.list-leave-active {
  transition: all 0.5s;
  position: absolute;
}

.list-enter /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.list-move {
  transition: all 1s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.header-span {
  margin-right: 26px;
}

.header_item {
  padding-left: 230px;
  padding-right: 0px;
}
</style>
